import React from 'react';

interface AddSectionModalProps {
  isOpen: boolean;
  sectionName: string;
  deliveryMethod: string;
  isSaving: boolean;
  onSectionNameChange: (name: string) => void;
  onDeliveryMethodChange: (method: string) => void;
  onSave: () => void;
  onCancel: () => void;
}

const AddSectionModal: React.FC<AddSectionModalProps> = ({
  isOpen,
  sectionName,
  deliveryMethod,
  isSaving,
  onSectionNameChange,
  onDeliveryMethodChange,
  onSave,
  onCancel
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
        
        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div className="sm:flex sm:items-start">
              <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
                <h3 className="text-lg leading-6 font-medium text-gray-900" id="modal-title">
                  Thêm Section mới
                </h3>
                <div className="mt-4">
                  <label htmlFor="section-name" className="block text-sm font-medium text-gray-700">
                    Tên Section
                  </label>
                  <input
                    type="text"
                    name="section-name"
                    id="section-name"
                    value={sectionName}
                    onChange={(e) => onSectionNameChange(e.target.value)}
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                    placeholder="Nhập tên section"
                  />
                </div>
                <div className="mt-4">
                  <label htmlFor="delivery-method" className="block text-sm font-medium text-gray-700">
                    Phương thức giảng dạy
                  </label>
                  <select
                    id="delivery-method"
                    name="delivery-method"
                    value={deliveryMethod}
                    onChange={(e) => onDeliveryMethodChange(e.target.value)}
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  >
                    <option value="e-learning">E-learning</option>
                    <option value="live-online">Live-online</option>
                    <option value="offline">Offline</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <button
              type="button"
              onClick={onSave}
              disabled={isSaving || !sectionName.trim()}
              className={`w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 ${
                isSaving || !sectionName.trim() ? 'bg-blue-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'
              } text-base font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm`}
            >
              {isSaving ? 'Đang lưu...' : 'Thêm'}
            </button>
            <button
              type="button"
              onClick={onCancel}
              disabled={isSaving}
              className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
            >
              Hủy
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddSectionModal; 